interface UseCamPlayerGridProps {
  camerasLength: number;
  hasAngles: boolean;
  multiCamViewActive: boolean;
  shouldRenderCompanionAd: boolean;
}

interface CamPlayerGridStateItem {
  mobile: number;
  tabletLg: number;
  desktop: number;
  desktopMd: number;
  desktopLg: number;
}

export type CamPlayerGridState = {
  container: CamPlayerGridStateItem;
  items: [
    CamPlayerGridStateItem,
    CamPlayerGridStateItem,
    CamPlayerGridStateItem,
    CamPlayerGridStateItem,
    CamPlayerGridStateItem,
  ];
  props: UseCamPlayerGridProps;
};

const getMainGridValues = ({
  camerasLength = 0,
  hasAngles = false,
  multiCamViewActive = false,
  shouldRenderCompanionAd = false,
}: UseCamPlayerGridProps): CamPlayerGridStateItem => {
  if (multiCamViewActive) {
    return {
      mobile: 1,
      tabletLg: camerasLength === 4 ? 10 : 12,
      desktop: camerasLength === 4 ? 10 : 12,
      desktopMd: camerasLength === 4 ? 10 : 12,
      desktopLg: camerasLength === 4 ? 10 : 12,
    };
  }
  return {
    mobile: 1,
    tabletLg: hasAngles ? 10 : 8,
    desktop: hasAngles ? 10 : 8,
    desktopMd: hasAngles && shouldRenderCompanionAd ? 6 : 8,
    desktopLg: hasAngles && shouldRenderCompanionAd ? 7 : 9,
  };
};

const useCamPlayerGrid = ({
  camerasLength = 0,
  hasAngles = false,
  multiCamViewActive = false,
  shouldRenderCompanionAd = false,
}: UseCamPlayerGridProps): CamPlayerGridState => {
  const mainGridValues = getMainGridValues({
    camerasLength,
    hasAngles,
    multiCamViewActive,
    shouldRenderCompanionAd,
  });
  const camPlayerGridState: CamPlayerGridState = {
    container: {
      mobile: 1,
      tabletLg: 12,
      desktop: 12,
      desktopMd: 12,
      desktopLg: 12,
    },
    items: [
      // Grid Left Padding
      {
        mobile: 0,
        tabletLg: multiCamViewActive ? 1 : 2,
        desktop: multiCamViewActive ? 1 : 2,
        desktopMd: multiCamViewActive ? 1 : 2,
        desktopLg: 1,
      },
      // Multicam container or Insights Container
      {
        mobile: mainGridValues.mobile,
        tabletLg: mainGridValues.tabletLg,
        desktop: mainGridValues.desktop,
        desktopMd: mainGridValues.desktopMd,
        desktopLg: mainGridValues.desktopLg,
      },
      // Cam angles
      {
        mobile: 1,
        tabletLg: 2,
        desktop: 2,
        desktopMd: 2,
        desktopLg: multiCamViewActive || hasAngles ? 2 : 1,
      },
      // Grid Right Padding
      {
        mobile: 0,
        tabletLg: multiCamViewActive ? 1 : 2,
        desktop: multiCamViewActive ? 1 : 2,
        desktopMd: multiCamViewActive ? 1 : 2,
        desktopLg: 1,
      },
      // Companion ad
      {
        mobile: 0,
        tabletLg: 0,
        desktop: 0,
        desktopMd: 4,
        desktopLg: 3,
      },
    ],
    props: {
      camerasLength,
      hasAngles,
      multiCamViewActive,
      shouldRenderCompanionAd,
    },
  };
  return camPlayerGridState;
};

export default useCamPlayerGrid;
